import { render, staticRenderFns } from "./ProjectField.vue?vue&type=template&id=62bfdf84"
import script from "./ProjectField.vue?vue&type=script&lang=js"
export * from "./ProjectField.vue?vue&type=script&lang=js"
import style0 from "./ProjectField.vue?vue&type=style&index=0&id=62bfdf84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports